import { Button, Space } from 'antd'
import React, { useState } from 'react'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import { UserSaleOffer } from 'src/core/models'
import styles from './SaleOfferDetailsButtons.module.scss'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import MakeCounterOfferModal from './MakeCounterOfferModal/MakeCounterOfferModal'
import { CheckCircleOutlined, CloseCircleOutlined, EditOutlined } from '@ant-design/icons'
import {
  rejectSaleOffferSelector,
  acceptSaleOffferSelector,
  acceptUserSaleOffer,
  rejectUserSaleOffer
} from 'src/features'

const SaleOfferDetailsButtons: React.FC<{ offer: UserSaleOffer }> = ({ offer }) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const route = useRouter().route
  const allowCounterOffer = offer.allow_counter_offer && !route?.endsWith('/admin')
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false)
  const { loading: loadingAccept } = useAppSelector(acceptSaleOffferSelector)
  const { loading: loadingReject } = useAppSelector(rejectSaleOffferSelector)

  return <>
    <div className={styles.content}>
      <Space direction='vertical' align='center'>
        {/* Accept */}
        <Button
          type='primary'
          loading={loadingAccept}
          className={styles.button}
          icon={<CheckCircleOutlined />}
          onClick={() => dispatch(acceptUserSaleOffer(offer.id))}
        >
          {loadingAccept ? t('SalesOffer.Accepting') : t('SalesOffer.AcceptOffer')}
        </Button>

        {/* Counter Offer */}
        {allowCounterOffer && (
          <Button
            type='default'
            className={styles.button}
            onClick={() => setIsModalVisible(true)}
            icon={<EditOutlined />}
          >
            {t('SalesOffer.MakeCounterOffer')}
          </Button>
        )}

        {/* Reject Offer */}
        <Button
          danger
          className={styles.button}
          loading={loadingReject}
          icon={<CloseCircleOutlined />}
          onClick={() => dispatch(rejectUserSaleOffer(offer.id))}
        >
          {loadingReject ? t('SalesOffer.Rejecting') :t('SalesOffer.RejectOffer')}
        </Button>
      </Space>
    </div>

    <MakeCounterOfferModal
      handleCancel={() => setIsModalVisible(false)}
      isModalVisible={isModalVisible}
      saleOffer={offer}
    />
  </>
}

export default SaleOfferDetailsButtons
